// Option lists and model defaults the player sections share.
//
// The two option lists were duplicated in step2 and then in both sections that
// own an animated overlay image (the autoplay illustration and the play
// button), so they live here once. Each factory takes the caller's `$t`,
// because the labels are translated: call it from a computed so the list
// rebuilds when the language changes.

// Values are animate.css class names and are stored on the video.
export function animationOptions($t) {
  return [
    { text: $t('frontend_groovevideo_animation_none'), value: 'none' },
    { text: $t('frontend_groovevideo_animation_tada'), value: 'tada' },
    { text: $t('frontend_groovevideo_animation_pulse'), value: 'pulse' },
    { text: $t('frontend_groovevideo_animation_zoomIn'), value: 'zoomIn' },
    { text: $t('frontend_groovevideo_animation_jello'), value: 'jello' },
    { text: $t('frontend_groovevideo_animation_wobble'), value: 'wobble' },
    { text: $t('frontend_groovevideo_animation_swing'), value: 'swing' },
    { text: $t('frontend_groovevideo_animation_bounceIn'), value: 'bounceIn' },
    { text: $t('frontend_groovevideo_animation_bounce'), value: 'bounce' },
    { text: $t('frontend_groovevideo_animation_flash'), value: 'flash' },
    { text: $t('frontend_groovevideo_animation_headshake'), value: 'headShake' },
    { text: $t('frontend_groovevideo_animation_heartbeat'), value: 'heartBeat' },
    { text: $t('frontend_groovevideo_animation_shakeX'), value: 'shakeX' },
    { text: $t('frontend_groovevideo_animation_shakeY'), value: 'shakeY' },
  ];
}

// The size scale both the illustration and the play button use.
export function sizeOptions($t) {
  return [
    { text: $t('frontend_groovevideo_videos_step2_small'), value: 1 },
    { text: $t('frontend_groovevideo_videos_step2_regular'), value: 2 },
    { text: $t('frontend_groovevideo_videos_step2_large'), value: 3 },
    { text: $t('frontend_groovevideo_videos_step2_huge'), value: 4 },
  ];
}

// The sections bind straight into these paths, so a video whose payload is
// missing one of them would render against `undefined`. The shell fills them
// before it snapshots the saved state; the panel repeats the call as a safety
// net and tells the shell which keys it had to add, so a video that only gets
// them here does not open looking unsaved.
//
// `set` is Vue's `$set`, needed because these are new keys on a watched object.
// Colour and watermark are filled by the shell's own fetch and are not repeated.
export function applyPlayerDefaults(model, set) {
  const assign = set || ((target, key, value) => { target[key] = value; });
  const filled = [];

  const defaults = {
    settings: {
      muted: false, autoplay: false, control: true, ytControls: false,
      color: { primary: 'rgba(253, 100, 129, 1)', secondary: 'rgba(255,255,255,1)' },
      watermark: { source: '', position: 'top-left' },
      overlay: { enable: false, txt: '' },
      autoplay_settings: { begin_again: 0, show_illustration: false, type: 1, custom_image: '' },
      unmute_image: 'ClickForSound_1.png', unmute_animation: 'none', unmute_size: 2,
    },
    play_button: { enable: false, show_on_pause: false, type: 1, library_source: '', custom_source: '', animation: 'none', size: 2 },
    video_dimensions: { type: '1', width: 1280, height: 720 },
  };
  function fill(target, values, rootKey) {
    Object.keys(values).forEach(key => {
      const value = values[key];
      if (target[key] == null) {
        assign(target, key, typeof value === 'object' ? JSON.parse(JSON.stringify(value)) : value);
        if (!filled.includes(rootKey || key)) filled.push(rootKey || key);
      } else if (typeof value === 'object' && typeof target[key] === 'object') {
        fill(target[key], value, rootKey || key);
      }
    });
  }
  fill(model, defaults);
  return filled;
}
